<template>
  <div v-if="versions.length">
    <table class="table table-borderless beast-table">
      <thead>
      <tr>
        <th class="beast-table-version">Version</th>
      </tr>
      </thead>
      <tbody>
      <tr v-bind:key="version"
          v-for="version in versions">
        <td class="beast-table-version">
          <router-link :to="`/package/${pkg.name}/${version}`">{{version}}</router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped lang="scss">
  .beast-table {
    .beast-table-version {
      a {
        color: $beast-dark-gray;

        &:hover {
          color: $beast-green
        }
      }
    }
  }
</style>

<script>
export default {
  props: {
    pkg: Object
  },
  watch: {
    async pkg() {
      await this.readData();
    }
  },
  data() {
    return {
      versions: []
    };
  },
  methods: {
    async readData() {
      const response = await this.axios.get(`/packages/${this.pkg.name}/versions`);
      this.versions = response.data;
    }
  },
  async beforeMount() {
    if (this.pkg.name !== "") {
      await this.readData();
    }
  }
};
</script>
